import React from "react"

export type ProcessProps = {
  step?: 0 | 1 | 2
}

export const Process: React.FC<ProcessProps> = ({ step }) => {
  return (
    <div className={"container"}>
      <svg
        width="100%"
        height="24"
        viewBox="0 0 244 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="12" fill="#FF8200" />
        <path
          d="M12 10.6666C10.8954 10.6666 10 11.5624 10 12.6666C10 13.7713 10.8954 14.6666 12 14.6666C13.1044 14.6666 14 13.7713 14 12.6666C14 11.5624 13.1044 10.6666 12 10.6666ZM17.3334 8.66665H15.7334C15.5134 8.66665 15.2763 8.49598 15.2068 8.28718L14.7932 7.04598C14.7235 6.83732 14.4867 6.66665 14.2667 6.66665H9.73337C9.51337 6.66665 9.27631 6.83732 9.20684 7.04612L8.79324 8.28732C8.72351 8.49598 8.48671 8.66665 8.26671 8.66665H6.66671C5.93337 8.66665 5.33337 9.26665 5.33337 9.99998V16C5.33337 16.7333 5.93337 17.3333 6.66671 17.3333H17.3334C18.0667 17.3333 18.6667 16.7333 18.6667 16V9.99998C18.6667 9.26665 18.0667 8.66665 17.3334 8.66665ZM12 16C10.1591 16 8.66671 14.5076 8.66671 12.6666C8.66671 10.8258 10.1591 9.33332 12 9.33332C13.8407 9.33332 15.3334 10.8258 15.3334 12.6666C15.3334 14.5076 13.8407 16 12 16ZM16.8667 10.9324C16.6091 10.9324 16.4 10.7236 16.4 10.4657C16.4 10.2081 16.6091 9.99905 16.8667 9.99905C17.1246 9.99905 17.3334 10.2081 17.3334 10.4657C17.3334 10.7236 17.1244 10.9324 16.8667 10.9324Z"
          fill="white"
        />
        <g opacity={step! >= 1 ? 1 : 0.6}>
          <g opacity="0.8">
            <circle
              cx="127"
              cy="12"
              r="12"
              fill={step! >= 1 ? "#FF8200" : "#1A1A1A"}
            />
          </g>
          <path
            d="M130.333 16C130.687 16 131.026 15.8595 131.276 15.6095C131.526 15.3594 131.667 15.0203 131.667 14.6667V8.66667C131.667 8.31304 131.526 7.97391 131.276 7.72386C131.026 7.47381 130.687 7.33333 130.333 7.33333H127.273C127.098 7.3326 126.931 7.26316 126.807 7.14L125.86 6.19333C125.736 6.07017 125.568 6.00074 125.393 6H121C120.646 6 120.307 6.14048 120.057 6.39052C119.807 6.64057 119.667 6.97971 119.667 7.33333V14.6667C119.667 15.0203 119.807 15.3594 120.057 15.6095C120.307 15.8595 120.646 16 121 16H130.333ZM124 8C124.198 8 124.391 8.05865 124.556 8.16853C124.72 8.27841 124.848 8.43459 124.924 8.61732C125 8.80004 125.019 9.00111 124.981 9.19509C124.942 9.38907 124.847 9.56725 124.707 9.70711C124.567 9.84696 124.389 9.9422 124.195 9.98079C124.001 10.0194 123.8 9.99957 123.617 9.92388C123.435 9.84819 123.278 9.72002 123.168 9.55557C123.059 9.39112 123 9.19778 123 9C123 8.73478 123.105 8.48043 123.293 8.29289C123.48 8.10536 123.735 8 124 8ZM130.333 14.3333C130.333 14.4217 130.298 14.5065 130.236 14.569C130.173 14.6315 130.088 14.6667 130 14.6667H121.333C121.245 14.6667 121.16 14.6315 121.098 14.569C121.035 14.5065 121 14.4217 121 14.3333V14.1067C121 14.0334 121.026 13.9624 121.073 13.9067L123 11.46C123.029 11.4246 123.064 11.3952 123.104 11.3734C123.144 11.3517 123.188 11.3381 123.233 11.3333C123.283 11.3328 123.332 11.3432 123.377 11.364C123.422 11.3847 123.462 11.4153 123.493 11.4533L124.46 12.62C124.491 12.6575 124.529 12.6878 124.573 12.7086C124.617 12.7293 124.665 12.7401 124.713 12.74C124.765 12.7395 124.816 12.7272 124.862 12.7041C124.908 12.681 124.949 12.6477 124.98 12.6067L126.9 10.1267C126.932 10.0864 126.972 10.0539 127.018 10.0316C127.065 10.0092 127.115 9.99759 127.167 9.99759C127.218 9.99759 127.269 10.0092 127.315 10.0316C127.361 10.0539 127.401 10.0864 127.433 10.1267L130.267 13.9067C130.309 13.9646 130.333 14.0346 130.333 14.1067V14.3333ZM133 10V16C133 16.3536 132.859 16.6928 132.609 16.9428C132.359 17.1929 132.02 17.3333 131.667 17.3333H122.333C122.333 17.687 122.474 18.0261 122.724 18.2761C122.974 18.5262 123.313 18.6667 123.667 18.6667H131.667C132.374 18.6667 133.052 18.3857 133.552 17.8856C134.052 17.3855 134.333 16.7072 134.333 16V11.3333C134.333 10.9797 134.193 10.6406 133.943 10.3905C133.693 10.1405 133.354 10 133 10Z"
            fill="white"
          />
        </g>
        {/* <g opacity={step! >= 2 ? 1 : 0.6}>
          <circle
            cx="232"
            cy="12"
            r="12"
            fill={step! >= 2 ? "#FF8200" : "#1A1A1A"}
          />
          <path
            d="M229.333 11.6273C229.333 11.716 229.298 11.8007 229.236 11.8633L228.569 12.53C228.504 12.5953 228.419 12.6273 228.333 12.6273C228.248 12.6273 228.163 12.5947 228.097 12.53L227.667 12.0993L227.236 12.53C227.106 12.66 226.895 12.66 226.765 12.53L226.098 11.8633C226.035 11.8007 226 11.716 226 11.6273V5.494L224.247 5.97267C224.101 6.01267 224 6.144 224 6.294V17.6273C224 17.778 224.101 17.9093 224.246 17.9487L231.333 19.882V4.03867L229.333 4.58533V11.6273ZM230.236 16.1967C230.17 16.262 230.085 16.294 230 16.294C229.915 16.294 229.829 16.2613 229.764 16.1967L229.333 15.766V16.9613C229.333 17.1453 229.184 17.2947 229 17.2947C228.816 17.2947 228.667 17.146 228.667 16.962V15.7667L228.236 16.1973C228.106 16.3273 227.895 16.3273 227.765 16.1973C227.635 16.0673 227.635 15.856 227.765 15.726L228.764 14.7267C228.795 14.696 228.832 14.6713 228.873 14.654C228.954 14.62 229.046 14.62 229.127 14.654C229.169 14.6707 229.205 14.6953 229.236 14.7267L230.235 15.726C230.366 15.856 230.366 16.066 230.236 16.1967ZM236.333 11.9607C237.221 11.9607 238.077 12.2313 238.809 12.7427C238.911 12.814 239.044 12.8233 239.154 12.7653C239.264 12.7087 239.333 12.594 239.333 12.4707V6.294C239.333 6.14333 239.233 6.012 239.087 5.97267L232 4.04V16.2947C232 13.9047 233.944 11.9607 236.333 11.9607ZM236.333 12.6273C234.311 12.6273 232.667 14.272 232.667 16.294C232.667 18.316 234.311 19.9607 236.333 19.9607C238.355 19.9607 240 18.316 240 16.294C240 14.2727 238.355 12.6273 236.333 12.6273ZM237.667 16.6273H236.667V17.6273C236.667 17.8113 236.517 17.9607 236.333 17.9607C236.149 17.9607 236 17.8113 236 17.6273V16.6273H235C234.816 16.6273 234.667 16.478 234.667 16.294C234.667 16.11 234.816 15.9607 235 15.9607H236V14.9607C236 14.7767 236.149 14.6273 236.333 14.6273C236.517 14.6273 236.667 14.7767 236.667 14.9607V15.9607H237.667C237.851 15.9607 238 16.11 238 16.294C238 16.478 237.851 16.6273 237.667 16.6273Z"
            fill="white"
          />
        </g>
        <line
          opacity="0.8"
          x1="32"
          y1="12.75"
          x2="107"
          y2="12.75"
          stroke={step! >= 1 ? "#FF8200" : "#fff"}
          strokeWidth="0.5"
        />
        <line
          opacity="0.8"
          x1="147"
          y1="12.75"
          x2="212"
          y2="12.75"
          stroke={step! >= 2 ? "#FF8200" : "#fff"}
          strokeWidth="0.5"
        /> */}
      </svg>

      {/*language=Stylus*/}
      <style jsx>{`
        .container {
          height 51px
          display flex
          justify-content center
          align-items center
          background #030821
          border 1px solid #030821
          padding 20px 0
        }
      `}</style>
    </div>
  )
}

Process.defaultProps = {
  step: 0
}
